import {
  doc,
  serverTimestamp,
  setDoc,
  collection,
  getDoc,
  getDocs,
  query,
  orderBy,
  deleteDoc,
} from "firebase/firestore";
import { ref, deleteObject } from "firebase/storage";
import { db, storage } from "../../firebase";

const collection_name = "sliders";

export default class SlidersAPI {
  // Add/Update Slider
  async setSlider(data, updateTime = true) {
    const payloadData = updateTime ? { updatedAt: serverTimestamp() } : {};
    try {
      await setDoc(
        doc(db, collection_name, data.id),
        { ...data.payload, ...payloadData },
        {
          merge: true,
        }
      );
      return { success: true };
    } catch (ex) {
      console.log("SlidersAPI setSlider error:", ex);
      return { success: false, message: ex };
    }
  }

  // Fetch all sliders
  async getSliders() {
    try {
      const q = query(
        collection(db, collection_name),
        orderBy("order", "asc")
      );
      const querySnapshot = await getDocs(q);
      let slidersArr = [];
      querySnapshot.forEach((doc) => {
        slidersArr.push({ id: doc.id, ...doc.data() });
      });
      return { success: true, data: slidersArr };
    } catch (ex) {
      // Fallback query if 'order' index/field might not be populated or causes error
      try {
        const fallbackQ = query(
          collection(db, collection_name),
          orderBy("createdAt", "desc")
        );
        const querySnapshot = await getDocs(fallbackQ);
        let slidersArr = [];
        querySnapshot.forEach((doc) => {
          slidersArr.push({ id: doc.id, ...doc.data() });
        });
        return { success: true, data: slidersArr };
      } catch (fallbackEx) {
        console.log("SlidersAPI getSliders error:", fallbackEx);
        return { success: false, message: fallbackEx };
      }
    }
  }

  // Fetch slider by id
  async getSliderById(sliderId) {
    try {
      const docRef = doc(db, collection_name, sliderId);
      const docSnap = await getDoc(docRef);
      if (docSnap.exists()) {
        return { success: true, data: docSnap.data() };
      } else {
        return { success: false, message: "No Slider Found" };
      }
    } catch (ex) {
      console.log("SlidersAPI getSliderById error:", ex);
      return { success: false, message: ex };
    }
  }

  // Delete slider image from storage
  async deleteSliderImage(imageName) {
    if (!imageName) return { success: true };
    try {
      const fileRef = ref(storage, `images/sliders/${imageName}`);
      await deleteObject(fileRef);
      return { success: true };
    } catch (ex) {
      console.log("Storage delete image warning:", ex?.message || ex);
      return { success: false, message: ex };
    }
  }

  // Delete slider document from Firestore and image from Storage
  async deleteSlider(sliderId, imageName = null) {
    try {
      // If imageName is provided, attempt to delete from storage
      if (imageName) {
        await this.deleteSliderImage(imageName);
      }
      await deleteDoc(doc(db, collection_name, sliderId));
      return { success: true };
    } catch (ex) {
      console.log("SlidersAPI deleteSlider error:", ex);
      return { success: false, message: ex };
    }
  }
}
